import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Box, Button, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Grid_Gap, Input_Width, Input_Width_LG } from '../../shared/constants'
import { useToaster } from '../../shared/utils/ToasterProvider'
import SprintWrapper from '../../shared/components/admin/SprintWrapper'
import AddIcon from '@mui/icons-material/Add';
import MilestonesWrapper from '../../shared/components/admin/MilestonesWrapper'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import ToggleSwitch from '../../shared/utils/CustomToggle'
import { useEffect, useRef, useState } from 'react'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { FormikQuillField } from '../../shared/components/formfields/FormikQuillField'
import { BulletListNumber } from '../../shared/utils/BulletList'
import { Icon } from '@iconify/react/dist/iconify.js'
import { CustomIconButton } from '../../shared/utils/IconButton'
import { RadioButtonGroupFormField } from '../../shared/components/formfields/RadioButtonField'
import { useLmsDropdownOptions } from '../../features/addlms/option/LsmOption';
import { postThreed } from '../../assets/nodeApi/postApi/postAdminApi';
import { useGetLmsUpdateContentById } from '../../assets/nodeApi/getApi/getAdminApi';
import { useParams } from 'react-router-dom';



const ThreejsAddQuestion = () => {
    const { lmsId } = useParams()
    const { data: lmsFullContent, isLoading } = useGetLmsUpdateContentById(lmsId)
    const [selectedCourseId, setSelectedCourseId] = useState();
    const [selectedQuestion, setSelectedQuestion] = useState({})
    const [activeIndexes, setActiveIndexes] = useState({ tIndex: null, sIndex: null, pIndex: null, qIndex: null, });
    const [selectedMilestone, setSelectedMilestone] = useState({});
    const [selectedSprint, setSelectedSprint] = useState({});
    const { open, handleClickOpen, handleClose } = useDialog();
    const { showToaster } = useToaster();
    const [courseMode, setCourseMode] = useState();
    const queryClient = useQueryClient();
    // const { lmsGrade, lmsTopic, lmsPublication, lmsLangauge, lmsBoard, lmsQuestionSource, lmsQuestionType, lmsCourses, lmsCourseType, lmsParagraLanguage } = useLmsDropdownOptions(selectedCourseId)
    const { lmsGrade, lmsTopic, lmsPublication, lmsLangauge, lmsBoard, lmsQuestionSource, lmsQuestionType, lmsCourses, lmsCourseType, lmsParagraLanguage, lmsSprint, lmsMilestone, lmsSession1, lmsCourseTypeOptions, CourseLevelOption, DificultyLevelOptions } = useLmsDropdownOptions({
        courseId: selectedCourseId,
        milestoneFilter: selectedCourseId,
        sprintFilter: selectedMilestone?.id,
        session1Filter: selectedSprint?.id,
        gradeFilter: { status: true },
        boardFilter: { status: true },
        courseFilter: { mode: courseMode }
    });


    const formikRef = useRef();
    const validationSchema = Yup.object().shape({
        eventId: Yup.string().required("Event is required"),
        gradeId: Yup.string().required("Grade is required"),
        boardId: Yup.string().required("Board is required"),
        languageId: Yup.string().required("Language is required"),
        publicationId: Yup.string().required("Publication is required"),

    });

    const initialValues = {
        eventId: lmsFullContent?.eventId,
        gradeId: lmsFullContent?.mapping?.grade?.id,
        boardId: lmsFullContent?.mapping?.board?.id,
        publicationId: lmsFullContent?.mapping?.publication?.id,
        languageId: lmsFullContent?.mapping?.language?.id,
    course_type: lmsFullContent?.mapping?.course_type,
            levelId: lmsFullContent?.mapping?.level?.id,

        subtopics: [
            {
                name: "",
                description: "",
                paragraphs: [
                    {
                        description: "",
                        language: "",
                        questions: [],
                    },
                ],
            },
        ],
    };


    // const mutationAddLMS = useMutation({
    //     mutationFn: postThreed,
    //     onSuccess: () => {
    //         showToaster('LMS Added successfully!', '', 'success');
    //         queryClient.invalidateQueries(['lmsTopicThreejs']);
    //         queryClient.invalidateQueries(['lmsSubtopicThreejs']);
    //         queryClient.invalidateQueries(['lmsSubtopicDetailThreejs']);
    //     },
    // });

    const mutationAddLMS = useMutation({
    mutationFn: postThreed,

    onSuccess: () => {
        showToaster('LMS Added successfully!', '', 'success');

        queryClient.invalidateQueries({
            queryKey: ['lms/displayCourses']
        });

        queryClient.invalidateQueries({
            queryKey: ['lmsTopicThreejs']
        });

        queryClient.invalidateQueries({
            queryKey: ['lmsSubtopicThreejs']
        });

        queryClient.invalidateQueries({
            queryKey: ['lmsSubtopicDetailThreejs']
        });
    },
});


    //   const initialValues = {
    //     "type": lmsFullContent?.mapping?.type || "",
    //     "eventId": lmsFullContent?.eventId,
    //     "gradeId": lmsFullContent?.mapping?.grade?.id,
    //     "boardId": lmsFullContent?.mapping?.board?.id,
    //     "publicationId": lmsFullContent?.mapping?.publication?.id,
    //     "languageId": lmsFullContent?.mapping?.language?.id,


    //     "course_type": lmsFullContent?.mapping?.course_type,
    //     "levelId": lmsFullContent?.mapping?.level?.id,
    //     "sessionId": lmsFullContent?.mapping?.sessionId || lmsFullContent?.mapping?.level?.id,
    //     "subtopics": [
    //         {
    //             "name": "",
    //             "description": "",
    //             "files": [],
    //             "paragraphs": [
    //                 {
    //                     "description": "",
    //                     "language": ""

    //                 }
    //             ],
    //         },

    //     ]
    // };
   
   
   
   
   
    const handleSubmit = (values, { resetForm }) => {
        const payload = {
            eventId: Number(values.eventId),
            languageId: Number(values.languageId),
            gradeId: Number(values.gradeId),
            boardId: Number(values.boardId),
            publicationId: Number(values.publicationId),
            levelId: Number(values.levelId),
            course_type: values.course_type,
            sessionId: Number(values.sessionId),
            subtopics: values.subtopics || [],
        };
        mutationAddLMS.mutate(payload, {
            onSuccess: () => {
                showToaster('LMS Added successfully!', '', 'success');
                resetForm()
                queryClient.invalidateQueries({ queryKey: ['lmsTopicThreejs'] });
                queryClient.invalidateQueries({ queryKey: ['lmsSubtopicThreejs'] });

            },
            onError: (err) => {
                showToaster(err?.response?.data?.error || 'Failed to Add LMS', '', 'error');
            },
        });
    };
    const onEditQuestion = (question, indexes) => {
        setSelectedQuestion(question);
        setActiveIndexes(indexes);
        handleClickOpen();
    };


    useEffect(() => {
        setSelectedCourseId(lmsFullContent?.eventId)
    }, [lmsId, isLoading])



    return (
        <>
            <NormalContainerWithHeader headerText={"Add ThreeJs"}>
                <Typography>Fill in the details to launch a ThreeJs</Typography>
                <CustomDivider />
                <Typography>Choose the course name from drop down</Typography>
                <CustomDivider />
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize>
                    {({ values, resetForm, setFieldValue }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>

                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="type"
                                        component={AutoCompleteField}
                                        label="Course Type Filter"
                                        isRequired
                                        options={lmsCourseTypeOptions.options}
                                        onValueChange={(value) => {
                                            setCourseMode(value?.value);
                                            setFieldValue("eventId", "");
                                            setSelectedCourseId(null);
                                        }}
                                        disabled={lmsId}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG} >
                                    <Field
                                        name="eventId"
                                        component={IdAutoCompleteField}
                                        options={lmsCourses.options}
                                        label="Course Name"
                                        isRequired={true}
                                        isLoading={lmsCourses.isLoading}
                                        onValueChange={(newValue) => {
                                            if (newValue) {
                                                setSelectedCourseId(newValue.id);
                                                setSelectedMilestone({})
                                                setSelectedSprint({})
                                                setFieldValue("milestoneId", "")
                                                setFieldValue("sprintId", "")
                                                setFieldValue("sessionId", "")
                                            } else {
                                                setSelectedCourseId(null);
                                            }
                                        }}
                                        // disabled={lmsId}
                                        disabled={!courseMode}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="course_type"
                                        component={AutoCompleteField}
                                        options={lmsCourseType.options}
                                        label="Course Type"
                                        isRequired={true}
                                        disabled={lmsId}

                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="boardId"
                                        component={IdAutoCompleteField}
                                        options={lmsBoard.options}
                                        label="Board"
                                        isRequired={true}
                                        isLoading={lmsBoard.isLoading}
                                        disabled={lmsId}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="languageId"
                                        component={IdAutoCompleteField}
                                        options={lmsLangauge.options?.filter((item) => String(item.status) === "1")}
                                        label="Language"
                                        isRequired={true}
                                        isLoading={lmsLangauge.isLoading}
                                        disabled={lmsId}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="gradeId"
                                        component={IdAutoCompleteField}
                                        options={lmsGrade.options}
                                        label="Grade"
                                        isRequired={true}
                                        isLoading={lmsGrade.isLoading}
                                        disabled={lmsId}


                                    />
                                </Grid2>

                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="publicationId"
                                        component={IdAutoCompleteField}
                                        options={lmsPublication.options?.filter((item) => String(item.status) === "1")}
                                        label="Publications"
                                        isRequired={true}
                                        isLoading={lmsPublication.isLoading}
                                        disabled={lmsId}


                                    />
                                </Grid2>


                                <Grid2 children size={12}>
                                    <Field
                                        name="levelId"
                                        component={RadioButtonGroupFormField}
                                        label="Course Level"
                                        isRequired
                                        options={CourseLevelOption.options}
                                        row
                                        isId={true}
                                         disabled={lmsId}
                                    />
                                </Grid2>


                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="milestoneId"
                                        component={IdAutoCompleteField}
                                        options={lmsMilestone.options}
                                        label="Milestone"
                                        isRequired={true}
                                        isLoading={lmsMilestone.isLoading}
                                        onValueChange={(newValue) => {
                                            if (newValue) {
                                                setSelectedMilestone(newValue);
                                                setSelectedSprint({})
                                                setFieldValue("sprintId", "")
                                                setFieldValue("sessionId", "")

                                            } else {
                                                setSelectedCourseId(null);
                                            }
                                        }}

                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width_LG}>
                                    <Field
                                        name="sprintId"
                                        component={IdAutoCompleteField}
                                        options={lmsSprint.options}
                                        label="Sprint"
                                        isRequired={true}
                                        isLoading={lmsSprint.isLoading}
                                        onValueChange={(newValue) => {
                                            if (newValue) {
                                                setSelectedSprint(newValue);
                                                setFieldValue("sessionId", "")
                                            } else {
                                                setSelectedSprint(null);
                                            }
                                        }}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name={`sessionId`}

                                        component={IdAutoCompleteField}
                                        options={lmsSession1.options}
                                        label="Topic"
                                        isRequired={true}
                                        isLoading={lmsSession1.isLoading}

                                    />
                                </Grid2>


                            </Grid2>
                            <CustomDivider />


                            <FieldArray name="subtopics">
                                {({ push: pushSubtopic, remove: removeSubtopic }) => (
                                    <>
                                        {values?.subtopics?.map((subTopic, sIndex) => (
                                            <MilestonesWrapper
                                                key={sIndex}
                                                headerText={`Script ${sIndex + 1}`}
                                                onDelete={() => removeSubtopic(sIndex)}
                                                sx={{ border: "1px solid #4169E1" }}
                                            >
                                                <Grid2 container spacing={Grid_Gap}>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`subtopics[${sIndex}].name`}
                                                            component={TextFormField}
                                                            label="Subtopic Name"
                                                        />
                                                    </Grid2>

                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`subtopics[${sIndex}].description`}
                                                            component={TextFormField}
                                                            label="Description"
                                                            multiline
                                                            row={3}
                                                        />
                                                    </Grid2>
                                                </Grid2>

                                                <CustomDivider />

                                                {/* ================= PARAGRAPHS ================= */}
                                                <FieldArray name={`subtopics[${sIndex}].paragraphs`}>
                                                    {({ push: pushParagraph, remove: removeParagraph }) => (
                                                        <>
                                                            {subTopic?.paragraphs?.map((paragraph, pIndex) => (
                                                                <SprintWrapper
                                                                    key={pIndex}
                                                                    headerText={`Paragraph ${pIndex + 1}`}
                                                                    onDelete={() => removeParagraph(pIndex)}
                                                                >
                                                                    <Grid2 container spacing={Grid_Gap}>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`subtopics[${sIndex}].paragraphs[${pIndex}].description`}
                                                                                component={FormikQuillField}
                                                                                label="Paragraph"
                                                                            />
                                                                        </Grid2>

                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`subtopics[${sIndex}].paragraphs[${pIndex}].language`}
                                                                                component={AutoCompleteField}
                                                                                options={lmsParagraLanguage.options}
                                                                                label="Language"
                                                                            />
                                                                        </Grid2>
                                                                    </Grid2>

                                                                    <CustomDivider />

                                                                    {/* ================= QUESTIONS ================= */}
                                                                    <FieldArray
                                                                        name={`subtopics[${sIndex}].paragraphs[${pIndex}].questions`}
                                                                    >
                                                                        {({ remove: removeQuestion }) => (
                                                                            <>
                                                                                {paragraph?.questions?.map((q, qIndex) => (
                                                                                    <MilestonesWrapper
                                                                                        key={qIndex}
                                                                                        headerText={`Question ${qIndex + 1}`}
                                                                                        onDelete={() => removeQuestion(qIndex)}
                                                                                        sx={{ border: "1px solid #4169E1" }}
                                                                                        leftContent={
                                                                                            <CustomIconButton
                                                                                                icon={
                                                                                                    <Icon
                                                                                                        icon="tabler:edit"
                                                                                                        color="#4169E1"
                                                                                                        fontSize={"30px"}
                                                                                                    />
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    onEditQuestion(
                                                                                                        values.subtopics[sIndex].paragraphs[
                                                                                                            pIndex
                                                                                                        ].questions[qIndex],
                                                                                                        { sIndex, pIndex, qIndex }
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                    >
                                                                                        <Grid2 container spacing={Grid_Gap}>
                                                                                            <Grid2 children size={12}>
                                                                                                <Box
                                                                                                    bgcolor={"#F7FAFF"}
                                                                                                    sx={{ p: 1, mb: 2 }}
                                                                                                >
                                                                                                    <Typography fontWeight={900}>
                                                                                                        {
                                                                                                            values.subtopics[sIndex].paragraphs[
                                                                                                                pIndex
                                                                                                            ].questions[qIndex].question_text
                                                                                                        }
                                                                                                    </Typography>
                                                                                                </Box>

                                                                                                <Box bgcolor={"#F7FAFF"} sx={{ p: 1 }}>
                                                                                                    <t
                                                                                                        items={
                                                                                                            values.subtopics[sIndex].paragraphs[
                                                                                                                pIndex
                                                                                                            ].questions[qIndex].answers
                                                                                                        }
                                                                                                    />
                                                                                                </Box>
                                                                                            </Grid2>
                                                                                        </Grid2>
                                                                                    </MilestonesWrapper>
                                                                                ))}

                                                                                <CustomDivider />

                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        justifyContent: "flex-end",
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        startIcon={<AddIcon />}
                                                                                        onClick={() => {
                                                                                            setSelectedQuestion({});
                                                                                            setActiveIndexes({
                                                                                                sIndex,
                                                                                                pIndex,
                                                                                                qIndex: null,
                                                                                            });
                                                                                            handleClickOpen();
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        Add Question
                                                                                    </Button>
                                                                                </Box>
                                                                            </>
                                                                        )}
                                                                    </FieldArray>
                                                                </SprintWrapper>
                                                            ))}

                                                            <CustomDivider />

                                                            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <Button
                                                                    startIcon={<AddIcon />}
                                                                    onClick={() =>
                                                                        pushParagraph({
                                                                            description: "",
                                                                            language: "",
                                                                            questions: [],
                                                                        })
                                                                    }
                                                                    variant="contained"
                                                                >
                                                                    Add Paragraph
                                                                </Button>
                                                            </Box>
                                                        </>
                                                    )}
                                                </FieldArray>
                                            </MilestonesWrapper>
                                        ))}

                                        {/* ADD SUBTOPIC */}
                                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                            <Button
                                                startIcon={<AddIcon />}
                                                onClick={() =>
                                                    pushSubtopic({
                                                        name: "",
                                                        description: "",
                                                        paragraphs: [],
                                                    })
                                                }
                                                variant="outlined"
                                            >
                                                Add Script
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </FieldArray>

                            <CustomDivider />

                            <Grid2 container spacing={Grid_Gap} mt={2}>
                                <Grid2 children size={Input_Width}>
                                    <Button
                                        variant="outlined"
                                        type="button"
                                        onClick={() => {
                                            resetForm();
                                        }}
                                        fullWidth
                                    >
                                        Reset
                                    </Button>
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        fullWidth
                                        disabled={mutationAddLMS.isPending}
                                    >
                                        {mutationAddLMS.isPending ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid2>

                            </Grid2>

                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"60%"} heading={"Add Questions"}>
                <Typography variant='body2'>
                    {selectedQuestion?.question_text
                        ? "Update the following details to modify this question"
                        : "Fill the following details to add a new question"}
                </Typography>
                <CustomDivider />
                <Formik
                    initialValues={{
                        "question_text": selectedQuestion?.question_text || "",
                        "question_type": selectedQuestion?.question_type || "",
                        "question_source": selectedQuestion?.question_source || "",
                        "difficulty_level": selectedQuestion?.difficulty_level || "",
                        "understanding_level": selectedQuestion?.understanding_level || "",
                        "answers": selectedQuestion?.answers ||
                            [
                                {
                                    "answer_text": "",
                                    "is_correct": true,
                                    "max_understanding_level": "",
                                    "min_understanding_level": ''
                                },
                            ]
                    }}

                    validationSchema={Yup.object().shape({
                        question_text: Yup.string()
                            .trim()
                            .required("Question text is required"),

                        question_type: Yup.string()
                            .required("Question type is required"),

                        question_source: Yup.string()
                            .required("Question source is required"),

                        difficulty_level: Yup.string()
                            .required("Difficulty level is required"),

                        understanding_level: Yup.string()
                            .required("Understanding level is required"),

                        answers: Yup.array()
                            .of(
                                Yup.object().shape({
                                    answer_text: Yup.string()
                                        .trim()
                                        .required("Answer text is required"),
                                    is_correct: Yup.boolean().required(),
                                    max_understanding_level: Yup.number()
                                        .required("Max understanding level is required"),
                                    min_understanding_level: Yup.number()
                                        .required("Min understanding level is required"),
                                })
                            )
                            .min(1, "At least one answer is required"),
                    })}

                    onSubmit={(questionValues, { resetForm }) => {
                        const { tIndex, sIndex, pIndex, qIndex } = activeIndexes;
                        const questionPath = `subtopics[${sIndex}].paragraphs[${pIndex}].questions`;

                        const existingQuestions =
                            formikRef.current.values.subtopics[sIndex].paragraphs[pIndex].questions;

                        if (qIndex !== null && qIndex !== undefined) {
                            // ✅ Edit mode: replace the existing question
                            const updatedQuestions = existingQuestions.map((q, index) =>
                                index === qIndex ? questionValues : q
                            );
                            formikRef.current.setFieldValue(questionPath, updatedQuestions);
                            showToaster('Question updated successfully!', '', 'success');
                        } else {
                            // ✅ Add mode: push new question
                            formikRef.current.setFieldValue(questionPath, [
                                ...existingQuestions,
                                questionValues,
                            ]);
                            showToaster('Question added successfully!', '', 'success');
                        }

                        handleClose();
                        resetForm();
                        setSelectedQuestion({});
                        setActiveIndexes({ tIndex: null, sIndex: null, pIndex: null, qIndex: null });
                    }}

                    enableReinitialize={true}

                >
                    {/* {({ values }) => ( */}
                    {({ values, setFieldValue }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={12}>
                                    <Field
                                        name={`question_text`}
                                        component={TextFormField}
                                        label="Question Text"
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name={`question_type`}
                                        label="Question Type"
                                        component={AutoCompleteField}
                                        options={lmsQuestionType.options}
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    {/* <Field
                                        name={`question_source`}
                                        component={AutoCompleteField}
                                        label="Question Source"
                                        options={lmsQuestionSource.options}
                                        isRequired={true}
                                    /> */}

                                    <Field
                                        name="question_source"
                                        component={AutoCompleteField}
                                        label="Question Source"
                                        options={lmsQuestionSource.options}
                                        isRequired={true}
                                        onValueChange={(value) => {

                                            const selected = value?.value || value;

                                            if (selected === "student_to_teacher") {
                                                setFieldValue("answers", [
                                                    {
                                                        answer_text: "",
                                                        is_correct: true,
                                                        max_understanding_level: "",
                                                        min_understanding_level: "",
                                                    },
                                                ]);
                                            } else if (selected === "teacher_to_student") {
                                                setFieldValue("answers", [
                                                    {
                                                        answer_text: "",
                                                        is_correct: true,
                                                        max_understanding_level: "",
                                                        min_understanding_level: "",
                                                    },
                                                ]);
                                            }
                                        }}
                                    />

                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="difficulty_level"
                                        component={RadioButtonGroupFormField}
                                        label="Difficulty Level"
                                        isRequired
                                        options={DificultyLevelOptions.options}
                                        row
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name={`understanding_level`}
                                        component={TextFormField}
                                        label="Understanding Level"
                                        type={"number"}
                                    />

                                </Grid2>
                                <Grid2 children size={12}>
                                    <FieldArray name={`answers`}>
                                        {({ push: pushAnswer, remove: removeAnswer }) => (
                                            <>

                                                {values.answers?.map((_, aIndex) => (
                                                    <SprintWrapper
                                                        key={aIndex}
                                                        headerText={`Answer ${aIndex + 1}`}
                                                        onDelete={() => removeAnswer(aIndex)}
                                                        sx={{ backgroundColor: "#FBFDFF" }}
                                                        leftContent={   // ✅ fixed spelling here
                                                            <Field name={`answers[${aIndex}].is_correct`}>
                                                                {({ field, form }) => (
                                                                    <ToggleSwitch
                                                                        checked={Boolean(field.value)}
                                                                        onCheck={(val) => form.setFieldValue(field.name, val)}
                                                                    />
                                                                )}
                                                            </Field>
                                                        }

                                                    >

                                                        <Typography variant='body2'>Fill the following details to add answer for the question</Typography>
                                                        <CustomDivider />
                                                        <Grid2 container spacing={Grid_Gap}>

                                                            <Grid2 children size={12}>
                                                                <Field
                                                                    name={`answers[${aIndex}].answer_text`}
                                                                    component={TextFormField}
                                                                    label="Write your Answer here"
                                                                />
                                                            </Grid2>
                                                            <Grid2 children size={12}>
                                                                <Field
                                                                    name={`answers[${aIndex}].max_understanding_level`}
                                                                    component={TextFormField}
                                                                    label="Maximum Understanding Level"
                                                                    type={"number"}
                                                                />
                                                            </Grid2>
                                                            <Grid2 children size={12}>
                                                                <Field
                                                                    name={`answers[${aIndex}].min_understanding_level`}
                                                                    component={TextFormField}
                                                                    label="Minimum Understanding Level "
                                                                    type={"number"}
                                                                />
                                                            </Grid2>

                                                        </Grid2>
                                                    </SprintWrapper>
                                                ))}
                                                <CustomDivider />
                                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                    {values.question_source === "teacher_to_student" && (
                                                        <Button
                                                            startIcon={<AddIcon />}
                                                            onClick={() =>
                                                                pushAnswer({
                                                                    answer_text: '',
                                                                    is_correct: true
                                                                })
                                                            }
                                                            variant="outlined"
                                                        >
                                                            Add Answer
                                                        </Button>
                                                    )}
                                                </Box>
                                            </>
                                        )}
                                    </FieldArray>
                                </Grid2>


                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>
                                        {selectedQuestion?.question_text ? "Update" : "Submit"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    )
}

export default ThreejsAddQuestion









